import script from "./Choose.vue?vue&type=script&setup=true&lang=ts"
export * from "./Choose.vue?vue&type=script&setup=true&lang=ts"

import "./Choose.vue?vue&type=style&index=0&id=bfb441ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb441ba"]])

export default __exports__